// An object, never a bare string: synapse's `DefaultPayload` requires a record payload.
export type OrganizationWorkflowRestoredPayload = {
	workflowKey: string;
};

export type OrganizationWorkflowRestoredAction = {
	type: 'ORGANIZATION_WORKFLOW_RESTORED';
	payload: OrganizationWorkflowRestoredPayload;
	organizationId: number;
};

export default (
	payload: OrganizationWorkflowRestoredPayload,
	organizationId: number,
): OrganizationWorkflowRestoredAction => ({
	type: 'ORGANIZATION_WORKFLOW_RESTORED',
	payload,
	organizationId,
});
